export interface GraphNode {
  id: number
  type: string
  title: string
  status?: string | null
  is_current?: boolean
  primary_parent?: { id: number; type: string; title: string } | null
  isGhost?: boolean
  ghostStep?: JourneyStep | null
  /** Count of unresolved blocker annotations ("what's getting in the way"). */
  active_blocker_count?: number
}

export interface GraphEdge {
  source: string
  target: string
  kind: 'structural' | 'semantic'
  relationship: string
}

export type JourneyStepStatus = 'locked' | 'unlocked' | 'completed'

export interface JourneyStep {
  step_id: string
  order: number
  title: string
  description: string
  child_type: string
  status: JourneyStepStatus
  entity_id?: number | null
  entity_type?: string | null
  estimated_duration_minutes?: number | null
}

export interface GoalJourney {
  goal_id: number
  plan_id: number | null
  current_step_index: number
  status: string
  steps: JourneyStep[]
}

export interface DreamGraphPayload {
  root: { id: number; type: string } | null
  current: { id: number; type: string } | null
  nodes: GraphNode[]
  edges: GraphEdge[]
  journeys?: GoalJourney[]
}

const BASE = '/api/hierarchy/graph'

export const hierarchyGraphService = {
  async getDreamGraph(nodeType: string, nodeId: number): Promise<DreamGraphPayload> {
    const resp = await fetch(`${BASE}/${nodeType}/${nodeId}`, {
      credentials: 'include',
    })
    if (!resp.ok) {
      const body = await resp.text()
      throw new Error(`hierarchyGraphService: ${resp.status} ${body}`)
    }
    return resp.json()
  },

  async getFullLifeMap(): Promise<DreamGraphPayload> {
    const resp = await fetch(`${BASE}/full`, { credentials: 'include' })
    if (!resp.ok) {
      const body = await resp.text()
      throw new Error(`hierarchyGraphService: ${resp.status} ${body}`)
    }
    return resp.json()
  },
}
